<template>
  <div class="wholesaler-my-profile">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-left">
        <span class="header-title">📦 NAPORLUN</span>
      </div>
      <button class="header-icon" @click="showMenu = !showMenu">☰</button>
    </header>

    <!-- 我的页面内容 -->
    <div class="my-content">
      <!-- 批发商信息 -->
      <div class="profile-info">
        <h2>{{ $t('Profile.line15_text') }}</h2>
        <p><strong>{{ $t('Profile.line16_text') }}</strong> {{ wholesalerName }}</p>
        <p><strong>{{ $t('Profile.line17_text') }}</strong> {{ wholesalerDescription }}</p>
      </div>

      <!-- 功能菜单 -->
      <div class="function-menu">
        <ul>
          <li @click="navigateTo('productManagement')">{{ $t('Profile.line23_text') }}</li>
          <li @click="navigateTo('orderManagement')">{{ $t('Profile.line24_text') }}</li>
          <li @click="navigateTo('deliveryManagement')">{{ $t('Profile.line25_text') }}</li>
          <li @click="navigateTo('driverManagement')">{{ $t('Profile.line26_text') }}</li>
          <li @click="navigateTo('storeInfoManagement')">{{ $t('Profile.line27_text') }}</li>
          <li @click="navigateTo('languageSettings')">{{ $t('Profile.line28_text') }}</li>
          <li @click="navigateTo('accountSettings')">{{ $t('Profile.line29_text') }}</li>
        </ul>
        
        <!-- 退出登录 - 单独显示在底部，红色强调 -->
        <div class="logout-section">
          <button class="btn-logout" @click="logout">
            <span class="logout-icon">🚪</span>
            <span>{{ $t('common.logout') }}</span>
          </button>
        </div>

        <!-- 删除账号 -->
        <div class="delete-account-section">
          <button class="btn-delete-account" @click="showDeleteAccount = true">{{ $t('common.deleteAccount') }}</button>
        </div>
      </div>
    </div>

    <!-- 底部导航 -->
    <nav class="bottom-nav">
      <button class="nav-item" @click="navigateTo('home')" :class="{ active: currentTab === 'home' }">
        <span class="nav-item-icon">🏠</span>
        <span>{{ $t('common.home') }}</span>
      </button>
      <button class="nav-item" @click="navigateTo('products')" :class="{ active: currentTab === 'products' }">
        <span class="nav-item-icon">🛒</span>
        <span>{{ $t('common.products') }}</span>
      </button>
      <button class="nav-item" @click="navigateTo('cart')" :class="{ active: currentTab === 'cart' }">
        <span class="nav-item-icon">🛍️</span>
        <span>{{ $t('common.cart') }}</span>
        <span v-if="cartCount > 0" class="cart-badge">{{ cartCount }}</span>
      </button>
      <button class="nav-item" @click="navigateTo('orders')" :class="{ active: currentTab === 'orders' }">
        <span class="nav-item-icon">📋</span>
        <span>{{ $t('common.orders') }}</span>
        <span v-if="pendingOrders > 0" class="cart-badge">{{ pendingOrders }}</span>
      </button>
      <button class="nav-item" @click="navigateTo('profile')" :class="{ active: currentTab === 'profile' }">
        <span class="nav-item-icon">👤</span>
        <span>{{ $t('common.profile') }}</span>
      </button>
    </nav>

    <!-- 删除账号弹窗 -->
    <div class="delete-account-modal" v-if="showDeleteAccount">
      <div class="modal-overlay" @click="showDeleteAccount = false">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h3>{{ $t('Profile.line78_text') }}</h3>
            <button class="close-btn" @click="showDeleteAccount = false">×</button>
          </div>
          <div class="modal-body">
            <p class="warning-text">{{ $t('Profile.line82_text') }}</p>
            <ul class="warning-list">
              <li>{{ $t('Profile.line84_text') }}</li>
              <li>{{ $t('Profile.line85_text') }}</li>
              <li>{{ $t('Profile.line86_text') }}</li>
              <li>{{ $t('Profile.line87_text') }}</li>
            </ul>
            <p class="warning-text danger">{{ $t('Profile.line89_text') }}</p>
          </div>
          <div class="modal-footer">
            <button class="btn-cancel" @click="showDeleteAccount = false">{{ $t('common.cancel') }}</button>
            <button class="btn-confirm-danger" @click="confirmDeleteAccount">{{ $t('common.confirmDelete') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { useRouter } from 'vue-router';
import api from '@/services/api';

export default {
  name: 'WholesalerMyProfile',
  data() {
    return {
      currentTab: 'profile',
      showMenu: false,
      wholesalerName: '张三水产', // 示例数据
      wholesalerDescription: '主营：新鲜海产品', // 示例数据
      cartCount: 2,
      pendingOrders: 3,
      showDeleteAccount: false
    };
  },
  computed: {
    ...mapGetters(['userName']),
    router() {
      return useRouter();
    }
  },
  methods: {
    navigateTo(tab) {
      this.currentTab = tab;
      switch (tab) {
        case 'home':
          this.router.push('/');
          break;
        case 'products':
          // 这里可以添加实际的产品页面路由
          break;
        case 'cart':
          // 这里可以添加实际的购物车页面路由
          break;
        case 'orders':
          // 这里可以添加实际的订单页面路由
          break;
        case 'profile':
          this.router.push('/my-profile');
          break;
        case 'productManagement':
          // 这里可以添加实际的产品管理页面路由
          break;
        case 'orderManagement':
          // 这里可以添加实际的订单管理页面路由
          break;
        case 'deliveryManagement':
          // 这里可以添加实际的配送管理页面路由
          break;
        case 'driverManagement':
          // 这里可以添加实际的配送员管理页面路由
          break;
        case 'storeInfoManagement':
          // 这里可以添加实际的店铺信息管理页面路由
          break;
        case 'languageSettings':
          // 这里可以添加实际的语言设置页面路由
          break;
        case 'accountSettings':
          // 这里可以添加实际的账户设置页面路由
          break;
      }
    },
    async logout() {
      try {
        // 调用 Vuex store 的 logout action
        await this.$store.dispatch('auth/logout');
        
        // 清空本地缓存（双重保险）
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('identity');
        localStorage.removeItem('identityId');
        
        // 跳转到登录页
        this.router.replace('/login');
        
        alert('✅ 已成功退出登录');
      } catch (error) {
        console.error('退出登录失败:', error);
        alert('❌ 退出登录失败：' + (error.message || '请重试'));
      }
    },
    async confirmDeleteAccount() {
      try {
        const res = await api.delete('/auth/account');
        if (res !== undefined && res !== null) {
          alert('✅ 账号已删除');
          this.showDeleteAccount = false;
          localStorage.clear();
          sessionStorage.clear();
          this.router.replace('/login');
        } else {
          alert('❌ 删除失败');
        }
      } catch (error) {
        console.error('删除账号失败:', error);
        alert('❌ 删除失败：' + (error.response?.data?.message || error.message));
      }
    }
  }
};
</script>

<style scoped>
.wholesaler-my-profile {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 60px;
}

.header {
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  padding: calc(12px + env(safe-area-inset-top, 0px)) 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}

.header-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  border-radius: 50%;
}

.header-icon:active {
  background: #f5f5f5;
}

.my-content {
  padding: 16px;
}

.profile-info {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-bottom: 16px;
}

.profile-info h2 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 8px;
}

.profile-info p {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.function-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.function-menu li {
  background: #fff;
  padding: 12px 16px;
  border-radius: 12px;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  cursor: pointer;
}

.function-menu li:active {
  transform: scale(0.98);
}

.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%; /* 确保宽度为100% */
  background: #fff;
  border-top: 1px solid #e8e8e8;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  z-index: 100;
  padding-bottom: env(safe-area-inset-bottom, 0);
  margin: 0 auto; /* 使导航栏居中 */
}

.nav-item {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  border-right: 1px solid #e8e8e8;
}

.nav-item:last-child {
  border-right: none;
}

.nav-item-icon {
  font-size: 20px;
  margin-bottom: 4px;
}

.nav-item.active {
  background: #f5f5f5;
}

.cart-badge {
  background: #FF6B35;
  color: #fff;
  border-radius: 50%;
  padding: 4px 8px;
  font-size: 12px;
  margin-left: 4px;
}

/* ========== 退出登录区域样式 ========== */
.logout-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e8e8e8;
}

.btn-logout {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a5a);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

.btn-logout:hover {
  background: linear-gradient(135deg, #ee5a5a, #dd4a4a);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);
}

.btn-logout:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(255, 107, 107, 0.3);
}

.logout-icon {
  font-size: 16px;
}

/* ========== 删除账号区域样式 ========== */
.delete-account-section {
  margin-top: 12px;
}

.btn-delete-account {
  width: 100%;
  padding: 12px 16px;
  background: none;
  color: #bbb;
  border: none;
  border-radius: 0;
  font-size: 13px;
  cursor: pointer;
  text-align: center;
}

.btn-delete-account:active {
  color: #999;
}

/* ========== 删除账号弹窗样式 ========== */
.delete-account-modal .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  opacity: 1 !important;
  visibility: visible !important;
}

.delete-account-modal .modal-content {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.delete-account-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.delete-account-modal .modal-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.delete-account-modal .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
}

.delete-account-modal .modal-body {
  padding: 20px;
}

.delete-account-modal .warning-text {
  font-size: 14px;
  color: #666;
  margin: 8px 0;
  line-height: 1.5;
}

.delete-account-modal .warning-text.danger {
  color: #f5576c;
  font-weight: bold;
}

.delete-account-modal .warning-list {
  margin: 8px 0;
  padding-left: 20px;
}

.delete-account-modal .warning-list li {
  font-size: 14px;
  color: #666;
  margin: 4px 0;
}

.delete-account-modal .modal-footer {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #eee;
}

.delete-account-modal .btn-cancel {
  flex: 1;
  padding: 12px;
  background: #f0f0f0;
  color: #666;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.delete-account-modal .btn-confirm-danger {
  flex: 1;
  padding: 12px;
  background: #f5576c;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

.delete-account-modal .btn-confirm-danger:active {
  background: #e04858;
}
</style>